import { SET_ALL_TRANSACTIONS, SET_RECENT_TRANSACTIONS } from './actionTypes';

const initialState = {
    allOverviewTransactions: null,
    recentTransactions: null
};

const Overview = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_TRANSACTIONS:
            state = { ...state, allOverviewTransactions: action.payload };
            break;
        case SET_RECENT_TRANSACTIONS:
            state = { ...state, recentTransactions: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default Overview;
